import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_CONTRATOS_URL}${process.env.VUE_APP_API_PATH}/contratos`

export default {
    obterTiposMovimentos(contratoId) {
        return axiosJwt
            .get(
                `${api}/comprometimentos/tiposmovimentos?contratoId=${contratoId}`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    atualizarMovimento(novoMovimento) {
        return axiosJwt
            .post(`${api}/comprometimentos/atualizarmovimento`, novoMovimento)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    }
}
